import React, { useState } from 'react';
import BackButton from '../components/BackButton';

const Grade = ({ onContinue, onBack }) => {
    const [selectedGrade, setSelectedGrade] = useState('10');

    const grades = ['3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];

    return (
        <div className="bg-background-light dark:bg-background-dark text-gray-800 dark:text-gray-100 min-h-screen flex flex-col font-sans antialiased transition-colors duration-300 selection:bg-primary-light selection:text-primary-dark">
            <nav className="w-full bg-surface-light/90 dark:bg-surface-dark/90 backdrop-blur-md border-b border-gray-100 dark:border-gray-800 sticky top-0 z-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-between h-16 items-center">
                        <div className="flex items-center gap-4">
                            <BackButton onClick={onBack} title="Go Back" />
                            <div className="flex items-center gap-2">
                                <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center text-white font-bold text-lg shadow-lg shadow-green-500/30">
                                    H
                                </div>
                                <span className="font-display font-bold text-xl tracking-tight text-gray-900 dark:text-white">Himigo</span>
                            </div>
                        </div>
                        <div className="hidden md:flex space-x-8">
                            <a className="text-gray-500 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors text-sm font-medium" href="#">Home</a>
                            <a className="text-gray-500 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors text-sm font-medium" href="#">Courses</a>
                            <a className="text-gray-500 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors text-sm font-medium" href="#">Mentors</a>
                        </div>
                        <div className="flex items-center gap-4">
                            <button className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
                                <span className="material-symbols-outlined">help</span>
                            </button>
                            <div className="w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-300 cursor-pointer" onClick={() => document.documentElement.classList.toggle('dark')}>
                                <span className="material-symbols-outlined text-lg">dark_mode</span>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            <main className="flex-grow flex items-center justify-center p-4 relative overflow-hidden py-12">
                <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-primary/10 rounded-full blur-3xl dark:bg-primary/5"></div>
                <div className="absolute bottom-[-10%] right-[-10%] w-96 h-96 bg-blue-500/10 rounded-full blur-3xl dark:bg-blue-500/5"></div>

                <div className="w-full max-w-4xl bg-surface-light dark:bg-surface-dark rounded-3xl shadow-2xl shadow-gray-200/50 dark:shadow-black/50 overflow-hidden z-10 border border-gray-100 dark:border-gray-700">
                    <div className="px-8 pt-10 pb-6 border-b border-gray-50 dark:border-gray-800">
                        <div className="flex items-center justify-center max-w-xs mx-auto mb-8">
                            <div className="flex items-center w-full">
                                <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm font-bold shrink-0">
                                    <span className="material-symbols-outlined text-base">check</span>
                                </div>
                                <div className="flex-grow h-1 bg-primary"></div>
                                <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-sm font-bold shrink-0 ring-4 ring-primary-light dark:ring-primary/20">
                                    2
                                </div>
                                <div className="flex-grow h-1 bg-gray-200 dark:bg-gray-700"></div>
                                <div className="w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-500 dark:text-gray-400 flex items-center justify-center text-sm font-bold shrink-0">
                                    3
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <h1 className="font-display font-bold text-3xl text-gray-900 dark:text-white mb-2">Select your grade</h1>
                            <p className="text-gray-500 dark:text-gray-400">Personalize your learning path by choosing your current grade level.</p>
                        </div>
                    </div>

                    <div className="p-8 md:p-12">
                        <form>
                            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 mb-10">
                                {grades.map((grade) => (
                                    <label key={grade} className="relative cursor-pointer group">
                                        <input
                                            type="radio"
                                            name="grade"
                                            className="sr-only peer"
                                            checked={selectedGrade === grade}
                                            onChange={() => setSelectedGrade(grade)}
                                        />
                                        <div className="p-6 rounded-2xl border-2 border-gray-100 dark:border-gray-800 bg-white dark:bg-gray-800 transition-all duration-200 hover:border-primary/50 text-center flex flex-col items-center gap-2 peer-checked:border-primary peer-checked:bg-primary/5 dark:peer-checked:bg-primary/10 peer-checked:ring-1 peer-checked:ring-primary">
                                            <span className={`font-display font-extrabold text-2xl transition-all ${selectedGrade === grade ? 'text-primary scale-110' : 'text-gray-400'}`}>
                                                {grade}
                                            </span>
                                            <span className="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider">Grade</span>
                                            <div className={`absolute top-2 right-2 w-5 h-5 rounded-full border-2 transition-colors flex items-center justify-center ${selectedGrade === grade ? 'bg-primary border-primary' : 'border-gray-200 dark:border-gray-600'}`}>
                                                <span className={`material-symbols-outlined text-xs font-bold transition-all ${selectedGrade === grade ? 'opacity-100 text-white' : 'opacity-0'}`}>
                                                    check
                                                </span>
                                            </div>
                                        </div>
                                    </label>
                                ))}
                            </div>

                            <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-gray-50 dark:border-gray-800">
                                <button
                                    onClick={onContinue}
                                    className="w-full sm:w-auto px-12 py-3.5 bg-primary hover:bg-primary-dark text-white rounded-xl shadow-lg shadow-primary/20 font-bold text-sm transition-all flex items-center justify-center hover:-translate-y-0.5"
                                    type="button"
                                >
                                    Confirm Selection
                                    <span className="material-symbols-outlined ml-2 text-xl">arrow_forward</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </main>

            <footer className="bg-surface-light dark:bg-surface-dark border-t border-gray-100 dark:border-gray-800 py-6 mt-auto">
                <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-sm text-gray-500 dark:text-gray-400">
                    <p>© 2023 Himigo Learning Platform. All rights reserved.</p>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <a className="hover:text-gray-900 dark:hover:text-white transition-colors" href="#">Privacy</a>
                        <a className="hover:text-gray-900 dark:hover:text-white transition-colors" href="#">Terms</a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Grade;
